import React, { useRef } from "react";
import axios from "axios";
import UploadIcon from "../../assets/images/UploadIcon.png";

function GuestFileUploadForm({ images, setImages, token, reload }) {
  const fileInputRef = useRef(null);

  // 새 이미지 업로드
  const handleFileChange = async (e) => {
    const files = Array.from(e.target.files);
    const formData = new FormData();

    files.forEach((file) => formData.append("file", file));

    await axios.post(`/api/space-feed/media?token=${token}`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    reload(); // 최신 이미지 다시 불러오기
  };

  // 기존 이미지 삭제
  const handleDelete = async (mediaId) => {
    await axios.delete(
      `/api/space-feed/media?mediaId=${mediaId}&token=${token}`
    );
    reload();
  };

  const handleKeepOnClick = () => {
    fileInputRef.current.click();
  };

  return (
    <>
      <div className="col-md-9">
        <div className="m-5">
          <div className="card">
            <div className="card-header">
              <h5 className="bold">Property Details</h5>
            </div>

            <div className="card-body">
              <span>Photos and Videos</span>
              <br />
              <span>Click below to upload photos and videos. Media will display in order</span>

              <div className="container d-flex justify-content-center w-100">
                <div className="filed">
                  <div className="upload-part m-5">
                    <div className="form-group file-area">
                      <input
                        type="file"
                        name="images"
                        id="images"
                        accept="image/png,image/jpeg,image/jpg,video/mp4,video/quicktime"
                        multiple
                        onChange={handleFileChange}
                        ref={fileInputRef}
                      />

                      <div className="file-dummy">
                        <div className="default">
                          <div className="image-block mb-2">
                            <img src={UploadIcon} alt="icon" />
                          </div>
                          <span style={{ fontWeight: "600" }}>
                            Add Photos/Videos
                          </span>
                          <br />
                          <span>Click or drag and drop to add files</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* 기존 이미지 미리보기 */}
              <div className="row mt-4">
                {images.map((img) => (
                  <div key={img.mediaId} className="col-md-3 mb-3">
                    <div className="card">
                      <img
                        src={img.url}
                        className="card-img-top"
                        alt="preview"
                        style={{ height: "150px", objectFit: "cover" }}
                      />
                      <div className="card-body text-center">
                        <button
                          className="btn btn-danger btn-sm"
                          onClick={() => handleDelete(img.mediaId)}
                        >
                          Delete
                        </button>
                      </div>
                    </div>
                  </div>
                ))}
              </div>

            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default GuestFileUploadForm;